import axios from 'axios';

const axiosInstance = axios.create();

export const getAxios = (): ReturnType<typeof axios.create> => {
    const glob = window ?? global;
    return (glob as any).soixa ?? axiosInstance;
};
